export default {
  administration: {
    title: 'Administration',
    sub: 'Administration de l\'application',
    exportSynchronisation: {
      title: 'Exports et synchronisation',
      export: {
        title: 'Derniers exports',
      },
      synchronisation: {
        title: 'Relancer une synchronisation',
      },
    },
    tablesReference: {
      title: 'Tables de référence',
      pays: {
        title: 'Pays',
      },
      region: {
        title: 'Régions',
      },
      departement: {
        title: 'Départements',
      },
      ville: {
        title: 'Villes',
      },
      typeAccesAgil: {
        title: 'Accès AGIL (Rôles)',
      },
      privilegeAgil: {
        title: 'Privilèges AGIL',
      },
      typeAcces: {
        title: 'Accès',
      },
      domaineActivite: {
        title: 'Domaines d\'activité',
      },
      secteurActivite: {
        title: 'Secteurs d\'activité',
      },
      civilite: {
        title: 'Civilités',
      },
      fonctionContact: {
        title: 'Fonction',
      },
      typeContact: {
        title: 'Types de contact',
      },
      typeDivision: {
        title: 'Types de division',
      },
      typeInstance: {
        title: 'Types d\'instance',
      },
      typeLait: {
        title: 'Types de lait',
      },
      typeParticipant: {
        title: 'Types de participant',
      },
      typePersonneMorale: {
        title: 'Types de personne morale',
      },
      demandeType: {
        title: 'Types de demande',
      },
      demandeStatus: {
        title: 'Statuts des demandes',
      },
    },
    personneMorale: {
      title: 'Personnes morales',
      personneMorale: {
        title: 'Personnes morales et divisions',
        list: {
          title: 'Personnes morales et divisions',
          sub: 'Liste des personnes morales et divisions',
          search: {
            personneMorale: 'Personne morale',
            division: 'Division',
          },
          table: {
            headers: {
              nomUsuel: 'Nom usuel',
              raisonSociale: 'Raison sociale',
              divisions: 'Divisions',
            },
          },
        },
        detail: {
          title: 'Personne morale',
          sub: 'Gestion avancée de la personne morale',
          form: {
            organisationPro: 'Organisation professionnelle',
          },
          buttons: {
            addDivision: 'Ajouter une division',
            addSubdivision: 'Ajouter une subdivision',
          },
          dialog: {
            division: {
              title: 'Création/modification de division',
              nom: 'Nom',
              typeDivision: 'Type',
              divisionSuperieure: 'Division supérieure',
            },
          },
        },
      },
      contextes: {
        title: 'Gestion des contextes',
        list: {
          title: 'Contextes',
          sub: 'Liste des contextes',
          search: {
            libelle: 'Contexte',
            description: 'Description',
          },
          table: {
            headers: {
              libelle: 'Contexte',
              description: 'Description',
            },
          },
        },
        detail: {
          title: 'Contexte',
          sub: 'Définition du contexte',
          form: {
            id: 'ID',
            libelle: 'Contexte',
            description: 'Description',
            commentaire: 'Commentaire',
            voit: 'Voit les contextes',
            visibleDe: 'Visible depuis les contextes',
            ceContexte: '[Ce contexte]',
          },
          results: {
            create: {
              success: 'Contexte créé avec succès',
              error: 'Erreur lors de la création du contexte',
            },
            update: {
              success: 'Contexte modifié avec succès',
              error: 'Erreur lors de la modification du contexte',
            },
            delete: {
              success: 'Contexte supprimé avec succès',
              error: 'Erreur lors de la suppression du contexte',
              errors: {
                referenced:
                  'Ce contexte est utilisé par une ou plusieurs personnes morales|Ce contexte est utilisé par 1 personne morale|Ce contexte est utilisé par {count} personnes morales',
                notFound: 'Contexte non trouvé',
              },
            },
          },
        },
      },
      cotisable: {
        title: 'Personnes morales cotisables',
        sub: 'Gestion des cotisables',
        add: 'Ajouter',
        remove: 'Supprimer',
        dialog: {
          description: 'Sélection de la personne morale',
        },
        list: {
          headers: {
            raisonSociale: 'Raison sociale',
            nomUsuel: 'Nom usuel',
            nombreCotisants: 'Nombre de cotisants',
            actions: 'Actions',
          },
          search: 'Filtrer par nom usuel ou raison sociale',
        },
        results: {
          create: {
            success: 'Cotisable créé avec succès',
            error: 'Erreur lors de la création du cotisable',
            errors: {
              doublon:
                'Cette personne morale existe déjà dans la liste des cotisables',
              personneMorale: {
                notFound: 'Personne morale non trouvée',
                noId: 'ID manquant',
              },
            },
          },
          delete: {
            success: 'Cotisable supprimé avec succès',
            error: 'Erreur lors de la suppression du cotisable',
            errors: {
              referenced:
                'Ce cotisable est utilisé par une ou plusieurs personnes morales|Ce cotisable est utilisé par 1 personne morale|Ce contexte est utilisé par {count} personnes morales',
              notFound: 'Cotisable non trouvé',
              noId: 'ID manquant',
            },
          },
        },
      },
    },
    profils: {
      title: 'Profils',
      autorisationAgil: {
        title: 'Habilitations AGIL',
        sub: 'Attribution des privilèges aux profils de l\'application AGIL',
        table: {
          headers: {
            id: 'Code',
            libelle: 'Privilège',
          },
        },
        confirmSave: {
          title: 'Confirmation d\'enregistrement',
          content: 'Voulez-vous enregistrer vos modifications ?',
        },
        confirmQuit: {
          title: 'Confirmation d\'abandon',
          content:
            'Vous avez des modifications en cours. Voulez-vous les abandonner ?',
        },
        results: {
          save: {
            success: 'Modifications enregistrées avec succès',
            error: 'Erreur lors de l\'enregistrement',
            noop: 'Aucun changement à enregistrer',
          },
        },
      },
    },
    rgpd: {
      title: 'RGPD',
      contacts: {
        title: 'Contacts avec date de validité dépassée',
        subtitle:
          'Liste des contacts dont la date limite de validité est atteinte',
      },
      alerteValidite: {
        title: 'Alertes de fin de validité',
        subtitle:
          'Liste des contacts dont la date limite de validité sera atteinte ou dépassée le : ',
        date: 'Date',
      },
      donneesRGPD: {
        title: 'Données RGPD',
        subtitle:
          'Vous souhaitez obtenir les données RGPD de la personne physique',
        exporter: 'Exporter les données',
      },
    },
    traitements: {
      title: 'Traitements',
    },
    mails: {
      detail: {
        title: 'Template de mail',
        sub: 'Consultation et modification d\'un template de mail',
      },
      liste: {
        title: 'Liste des templates de mail',
        sub: 'Accès aux templates de mail du système',
      },
      historique: {
        title: 'Historique des mails de création de compte',
        list: {
          title: 'Historique des mails de création de compte',
          sub: 'Accès a l\'historique des mails de création de compte',
          table: {
            headers: {
              nom: 'Nom',
              prenom: 'Prénom',
              email: 'Email',
              dateCreation: 'Date de création',
              dateEnvoi: 'Date d\'envoi',
              etat: 'Etat',
              actions: 'Actions',
            },
          },
          search: {
            nom: 'Nom',
            prenom: 'Prénom',
            etat: 'Etat',
          },
        },
      },

      title: 'Paramétrage des mails',
    },
    corbeille: {
      title: 'Gestion de la corbeille',
      corbeille: {
        title: 'Corbeille',
      },
    },
    parametreenum: {
      search: {
        libelle: 'Libellé',
        code: 'Code',
      },
      table: {
        headers: {
          id: 'id',
          code: 'Code',
          libelle: 'Libellé',
          libelleCourt: 'Libellé court',
          actif: 'Actif',
          actions: 'Actions',
          extra: {
            codePostal: 'Code postal',
            region: 'Région',
          },
        },
        fields: {
          actif: {
            true: 'Actif',
            false: 'Inactif',
          },
        },
      },
      buttons: {
        confirm: 'Valider',
        cancel: 'Annuler',
        quit: 'Quitter',
      },
      form: {
        id: 'id',
        code: 'Code',
        libelle: 'Libellé',
        libelleCourt: 'Libellé court',
        actif: 'Actif',
        ville: {
          codePostal: 'Code postal',
        },
        departement: {
          region: 'Région',
        },
        typeAccesAgil: {
          description: 'Description',
        },
        privilegeAgil: {
          description: 'Description',
        },
        typeAcces: {
          description: 'Description',
        },
        dialog: {
          title: {
            create: '(création)',
            update: '(modification)',
          },
        },
      },
      results: {
        load: {
          error: 'Erreur lors du chargement des paramètres',
        },
        update: {
          success: 'Paramètre modifié avec succès',
          error: 'Erreur lors de la modification du paramètre',
          invalid: 'Saisie incorrecte',
        },
        create: {
          success: 'Paramètre créé avec succès',
          error: 'Erreur lors de la création du paramètre',
          invalid: 'Saisie incorrecte',
        },
        noop: {
          invalid: 'Opération non valide',
        },
        deactivate: {
          success: 'Paramètre désactivé avec succès',
        },
        cancel: {
          success: 'Opération annulée',
        },
      },
    },
  },
};
